import { isAndroid, isIOS } from "../utils";
import { GROWTHBOOK_TARGET_VARIANTS } from "./features";

export const getTarget = () => {
    if (isAndroid()) {
        return GROWTHBOOK_TARGET_VARIANTS.ANDROID;
    } else if (isIOS()) {
        return GROWTHBOOK_TARGET_VARIANTS.IOS;
    } else {
        return GROWTHBOOK_TARGET_VARIANTS.WEB_DESKTOP;
    }
}